import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AdminCreateUserPayload } from "./UsersApi";

interface UsersCreateState {
  loading: boolean;
  data: any;
  error: any;
}

const initialState: UsersCreateState = {
  loading: false,
  data: null,
  error: null,
};

const UsersCreateSlicer = createSlice({
  name: "UsersCreate",
  initialState,
  reducers: {
    adminCreateUser(state, _action: PayloadAction<AdminCreateUserPayload>) {
      state.loading = true;
      state.error = null;
    },
    successCreateUser(state, action: PayloadAction<any>) {
      state.loading = false;
      state.data = action.payload;
      state.error = null;
    },
    failureCreateUser(state, action: PayloadAction<any>) {
      state.loading = false;
      state.error = action.payload;
    },
    clearCreateUserState(state) {
      state.loading = false;
      state.data = null;
      state.error = null;
    },
  },
});

export const {
  adminCreateUser,
  successCreateUser,
  failureCreateUser,
  clearCreateUserState,
} = UsersCreateSlicer.actions;

export default UsersCreateSlicer.reducer;

